/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * The data-ids used in the Datastore screen.
 */
export const DATASTORE_DATA_IDS = {
  buttonCliFindOutMore: `Button: Find out more about the CLI`,
};
